import { useNavigate } from 'react-router-dom'

import BigCard from '@/components/common/card/BigCard'
import PrivacyPolicy from '@/assets/PrivacyPolicy'
import NormalTopBar from '@/components/common/bar/NormalTopBar'
import { useScrollToTop } from '@/hooks/useScrollToTop'

const PrivacyPage = () => {
  useScrollToTop()

  const navigate = useNavigate()

  return (
    <>
      <NormalTopBar
        title='개인정보 처리방침'
        prevButton
        onPrevButtonClick={() => navigate('/my')}
        textClassName='text-xl text-text-header font-semibold'
        boxClassName='bg-gradient-to-r from-amber-400 to-yellow-300'
      />
      <div className='min-h-screen p-3 overflow-y-hidden flex flex-col gap-3'>
        <BigCard className='bg-white px-3 py-5'>
          <PrivacyPolicy />
        </BigCard>
      </div>
    </>
  )
}

export default PrivacyPage
